import React from "react";
import "./review.css";
import { ImQuotesLeft } from "react-icons/im";
import { ImQuotesRight } from "react-icons/im";
import { AiTwotoneStar } from "react-icons/ai";

const Review = () => {
  return (
    <>
      <div className="review-section" id="t">
        <div className="why-choose-us-text-container review-head-container">
          <div className="header review-header" data-aos="fade-up">
            <span className="header-line"></span>
            <h2>what our custormers are saying</h2>
          </div>
          <h1 data-aos="fade-up">custormer reviews</h1>
        </div>
        <div className="review-card-container">
          <div className="review-card" data-aos="fade-up">
            <div className="review-card-img-container">
              <img src="/gregory-gill-4Bf5LNEPqZ0-unsplash.jpg" alt="" />
              <div className="review-card-rating-container">
                <div className="rate-icon-container">
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                </div>
                <p className="investor-name">Elise</p>
              </div>
            </div>
            <div className="investor-review-container">
              <span className="right-quote">
                <ImQuotesLeft />
              </span>
              <p>
                Je n'ai jamais cru aux systèmes sécurisés jusqu'à ce que je
                découvre QFS Ledger Security. Ce coffre-fort est tout simplement
                le meilleur, je le recommande à tous.
              </p>
              <span className="left-quote">
                <ImQuotesRight />
              </span>
            </div>
          </div>
          <div className="review-card" data-aos="fade-up">
            <div className="review-card-img-container">
              <img src="/fortune-vieyra-QIMjYJSFoXM-unsplash.jpg" alt="" />
              <div className="review-card-rating-container">
                <div className="rate-icon-container">
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                </div>
                <p className="investor-name">Michael M.</p>
              </div>
            </div>
            <div className="investor-review-container">
              <span className="right-quote">
                <ImQuotesLeft />
              </span>
              <p>
                This new innovation of QFS is just top notch, now i dont have to
                be afraid of crypto fluctuations like before again.
              </p>
              <span className="left-quote">
                <ImQuotesRight />
              </span>
            </div>
          </div>
          <div className="review-card" data-aos="fade-up">
            <div className="review-card-img-container">
              <img src="/jurica-koletic-7YVZYZeITc8-unsplash.jpg" alt="" />
              <div className="review-card-rating-container">
                <div className="rate-icon-container">
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                  <AiTwotoneStar />
                </div>
                <p className="investor-name">Michael H.</p>
              </div>
            </div>
            <div className="investor-review-container">
              <span className="right-quote">
                <ImQuotesLeft />
              </span>
              <p>
                All thanks to QUANTUM FINANCIAL SYSTEM my crypto wallet is now
                safe, no more losses ...{" "}
              </p>
              <span className="left-quote">
                <ImQuotesRight />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Review;
